<template>
  <el-form label-position="right" label-width="160px">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="16" :md="18" :lg="18" :xl="20">
        <el-form-item :label="$t('forma-pagamento')" prop="paymentType">
          <el-radio @change="received" v-model="paymentType" label="1">Dinheiro</el-radio>
          <el-radio @change="received" v-model="paymentType" label="2">Cartão de débito</el-radio>
          <el-radio @change="received" v-model="paymentType" label="3">Cartão de crédito</el-radio>
          <el-radio @change="received" v-model="paymentType" label="4">PIX</el-radio><el-button type="primary"
            @click="qrcode(true)" v-if="paymentType === '4'">Pagar pela
            plataforma</el-button>
        </el-form-item>

      </el-col>
    </el-row>
    <div class="row">
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <PaymentFinished ref="finished" type="pix" :id="payment.id" :url="payment.url" @generate="qrcode" />
        <div class="card" style="height: 100px;">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-9">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold">Valor Recebido</p>
                  <h5 class="font-weight-bolder red">
                    <el-input :disabled="paymentType !== '1'" :placeholder="$t('numero')" type="number"
                      style="width: 130px;" pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" :min="0"
                      v-model="money"></el-input>
                  </h5>
                </div>
              </div>
              <div class="col-3 text-end">
                <div class="icon icon-shape bg-gradient-success shadow-primary text-center rounded-circle">
                  <i class="ni ni-money-coins text-lg opacity-10" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <div class="card" style="height: 100px;">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-9">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold" v-if="changed > 0">Troco</p>
                  <p class="text-sm mb-0 text-uppercase font-weight-bold" v-else>Faltando</p>
                  <h5 class="font-weight-bolder green" v-if="changed > 0">
                    {{
                      changed
                      | currency("R$ ", 2, {
                        thousandsSeparator: ".",
                        decimalSeparator: ",",
                      })
                    }}
                  </h5>
                  <h5 class="font-weight-bolder red" v-else>
                    {{
                      changed
                      | currency("R$ ", 2, {
                        thousandsSeparator: ".",
                        decimalSeparator: ",",
                      })
                    }}
                  </h5>
                </div>
              </div>
              <div class="col-3 text-end">
                <div class="icon icon-shape bg-gradient-default shadow-primary text-center rounded-circle">
                  <i class="fa fa-money text-lg opacity-10" style="color: white" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>
<script>
import { PaymentService } from "@/services/customers/payment.services";
import PaymentFinished from '../../../views/dashboard/financial/payment/PaymentFinished';
export default {
  name: "PdvClosedValues",
  props: ["pay", "licence"],
  components: {
    PaymentFinished,
  },
  data() {
    return {
      paymentType: '2',
      money: 0,
      payment: {
        url: '',
        qrcode: '',
        id: ''
      }
    }
  },
  computed: {
    changed() {
      const vm = this;
      if (vm.paymentType === '1') { return +((+('' + vm.money).replace(',', '.')) - vm.pay).toFixed(2) }
      return 0;
    },
  },
  methods: {
    qrcode(newQrcode) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      console.log('vm.$refs', vm.$refs)
      PaymentService.pix({
        value: +vm.pay,
        description: "MaisEnvios - PDV",
        customer: {
          name: vm.licence.name,
          federalid: vm.licence.federalid,
          mail: vm.licence.mail,
        }
      })
        .then((response) => {
          vm.payment.id = response.id;
          vm.payment.url = response.url;
          vm.payment.qrcode = response.qrcode;
          setTimeout(() => {
            console.log('vm.$refs', vm.$refs)
            if (newQrcode) {
              vm.$refs.finished.open();
              vm.$refs.finished.updated();
            }
            else vm.$refs.finished.updated();
          }, 200)
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        }).finally(() => loading.close())

    },
    paymentData() {
      const vm = this;
      return [{
        paymentType: vm.paymentType,
        money: vm.paymentType !== '1' ? vm.pay : vm.money,
        changed: vm.changed,
      }]
    },
    clear() {
      this.paymentType = '2';
      this.type = '0';
      this.money = 0;
    },
    received() {
      console.log('this.licence', this.licence)
      const vm = this;
      if (vm.paymentType !== '1') { vm.money = vm.pay }
      else vm.money = 0;
    },
  }
}
</script>

<style>
.red {
  color: red;
}

.green {
  color: #67C23A;
}
</style>

